<div class="dialog style-library-picker-dialog">
  @if (!hasEntries) {
    <p class="library-empty">No saved styles yet — use Copy style to add one.</p>
  } @else {
    <div class="label-background library-picker-background poe-scrollbar" [style.background-image]="labelBackgroundImage()">
      @for (row of previewRows; track row.entry.id) {
        <div app-label-viewer
          [clickable]="true"
          [disableBackground]="true"
          [displayOptions]="row.displayOptions"
          [exampleName]="row.entry.name"
          [rarity]="rarity"
          [sockets]="sockets"
          [influence]="influence"
          [fractured]="fractured"
          [veiled]="veiled"
          [synthesised]="synthesised"
          [isCurrency]="isCurrency"
          [isWaystone]="isWaystone"
          [isPoe1Gem]="isPoe1Gem"
          [isDivinationCard]="isDivinationCard"
          [isQuestItem]="isQuestItem"
          [forceHidden]="forceHidden"
          (clickLabel)="selectEntry(row.entry)">
        </div>
      }
    </div>
  }

  <div class="controls dialog-controls">
    <button type="button" class="btn dialog-btn" [disabled]="!hasMultipleEntries" (click)="clearAllButLast()">
      Clear all but last
    </button>
    <button type="button" class="btn dialog-btn dialog-cancel-btn" (click)="closeDialog()">
      Cancel
    </button>
  </div>
</div>
